```vue
<template>
  <transition name="modalFade">
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-70">
      <div class="bg-gray-800 rounded-lg w-full max-w-3xl p-6 shadow-lg border border-gray-600 animate-scale">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-lg font-semibold text-indigo-300">เพิ่มสูตรคราฟ</h3>
          <button @click="closeModal" class="text-gray-300 hover:text-indigo-300 group">
            <i class="fas fa-times text-base group-hover:scale-110 transition-transform duration-200"></i>
          </button>
        </div>
        <div class="space-y-4">
          <div v-if="error" class="text-red-300 text-sm text-center">
            {{ error }}
          </div>
          <div class="grid grid-cols-3 gap-4">
            <div>
              <label for="newCraftName" class="block text-indigo-200 mb-1 text-sm">ชื่อไอเทม</label>
              <input
                id="newCraftName"
                v-model="newCraftRecipe.name"
                type="text"
                class="w-full bg-gray-700 text-indigo-200 border border-gray-600 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
                placeholder="เช่น ดาบไม้"
              />
            </div>
            <div>
              <label for="newCraftType" class="block text-indigo-200 mb-1 text-sm">ประเภท</label>
              <select
                id="newCraftType"
                v-model="newCraftRecipe.type"
                class="w-full bg-gray-700 text-indigo-200 border border-gray-600 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
              >
                <option value="">เลือกประเภท</option>
                <option v-for="option in craftTypes" :key="option.value" :value="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
            <div>
              <label for="newCraftLevel" class="block text-indigo-200 mb-1 text-sm">ระดับ</label>
              <input
                id="newCraftLevel"
                v-model.number="newCraftRecipe.level"
                type="number"
                min="1"
                class="w-full bg-gray-700 text-indigo-200 border border-gray-600 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
                placeholder="เช่น 1"
              />
            </div>
          </div>
          <div class="grid grid-cols-2 gap-4">
            <div>
              <label for="newCraftRequiredInt" class="block text-indigo-200 mb-1 text-sm">ความฉลาดที่ต้องใช้</label>
              <input
                id="newCraftRequiredInt"
                v-model.number="newCraftRecipe.requiredInt"
                type="number"
                min="0"
                class="w-full bg-gray-700 text-indigo-200 border border-gray-600 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
                placeholder="เช่น 80"
              />
            </div>
            <div>
              <label for="newCraftRequiredSkill" class="block text-indigo-200 mb-1 text-sm">ทักษะที่ต้องใช้ (ถ้ามี)</label>
              <input
                id="newCraftRequiredSkill"
                v-model="newCraftRecipe.requiredSkill"
                type="text"
                class="w-full bg-gray-700 text-indigo-200 border border-gray-600 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
                placeholder="เช่น หนังสือวิธีการทำหน้ากาก"
              />
            </div>
          </div>
          <div class="grid grid-cols-3 gap-4">
            <div>
              <label for="newCraftMaxCrafts" class="block text-indigo-200 mb-1 text-sm">จำนวนครั้งที่คราฟได้ (ว่างไว้ถ้าไม่จำกัด)</label>
              <input
                id="newCraftMaxCrafts"
                v-model.number="newCraftRecipe.maxCrafts"
                type="number"
                min="1"
                class="w-full bg-gray-700 text-indigo-200 border border-gray-600 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
                placeholder="เช่น 5"
              />
            </div>
            <div>
              <label for="newCraftTransferChance" class="block text-indigo-200 mb-1 text-sm">โอกาสโอนได้ (%)</label>
              <input
                id="newCraftTransferChance"
                v-model.number="newCraftRecipe.transferChance"
                type="number"
                min="0"
                max="100"
                class="w-full bg-gray-700 text-indigo-200 border border-gray-600 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
                placeholder="เช่น 0"
              />
            </div>
            <div>
              <label for="newCraftSuccessChance" class="block text-indigo-200 mb-1 text-sm">โอกาสสำเร็จ (%)</label>
              <input
                id="newCraftSuccessChance"
                v-model.number="newCraftRecipe.successChance"
                type="number"
                min="0"
                max="100"
                class="w-full bg-gray-700 text-indigo-200 border border-gray-600 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
                placeholder="เช่น 80"
              />
            </div>
          </div>
          <div class="grid grid-cols-2 gap-4">
            <div>
              <label for="newCraftExpirationDate" class="block text-indigo-200 mb-1 text-sm">วันและเวลาหมดอายุ (ว่างไว้ถ้าไม่มี)</label>
              <input
                id="newCraftExpirationDate"
                v-model="newCraftRecipe.expirationDate"
                type="datetime-local"
                class="w-full bg-gray-700 text-indigo-200 border border-gray-600 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
              />
            </div>
            <div class="flex items-center">
              <input
                id="newCraftIsRecommended"
                v-model="newCraftRecipe.isRecommended"
                type="checkbox"
                class="bg-gray-700 rounded text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-600 border border-gray-600"
              />
              <label for="newCraftIsRecommended" class="ml-2 text-indigo-200 text-sm">แนะนำสูตรนี้</label>
            </div>
          </div>
          <div>
            <label class="block text-indigo-200 mb-1 text-sm">วัตถุดิบ</label>
            <div v-for="(material, index) in newCraftRecipe.materials" :key="index" class="flex items-center gap-2 mb-2">
              <input
                v-model="material.itemName"
                type="text"
                class="flex-1 bg-gray-700 text-indigo-200 border border-gray-600 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
                placeholder="ชื่อวัตถุดิบ"
              />
              <input
                v-model.number="material.quantity"
                type="number"
                min="1"
                class="w-20 bg-gray-700 text-indigo-200 border border-gray-600 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
                placeholder="จำนวน"
              />
              <button
                v-if="newCraftRecipe.materials.length > 1"
                @click="removeMaterial(index)"
                class="bg-red-600 hover:bg-red-500 text-white rounded-md p-2 text-sm transition-all duration-200 group"
              >
                <i class="fas fa-minus text-sm group-hover:scale-110"></i>
              </button>
            </div>
            <button
              @click="addMaterial"
              class="bg-indigo-600 hover:bg-indigo-500 text-white rounded-md p-2 text-sm font-semibold transition-all duration-200 group"
            >
              <i class="fas fa-plus mr-1 text-sm group-hover:scale-110"></i> เพิ่มวัตถุดิบ
            </button>
          </div>
          <div class="flex justify-end gap-4 mt-4">
            <button
              @click="addRecipe"
              :class="[
                'flex items-center bg-indigo-600 text-white px-4 py-2 rounded-md font-semibold transition-all duration-200 border border-indigo-600 text-sm group',
                { 'opacity-50 cursor-not-allowed': isAdding },
              ]"
              :disabled="isAdding"
            >
              <span v-if="!isAdding">
                <i class="fas fa-plus mr-1 text-sm group-hover:scale-110"></i> เพิ่ม
              </span>
              <span v-else>
                <i class="fas fa-spinner animate-spin-pulse text-sm"></i>
              </span>
            </button>
            <button
              @click="closeModal"
              class="flex items-center bg-gray-600 hover:bg-gray-500 text-white px-4 py-2 rounded-md font-semibold transition-all duration-200 border border-gray-700 text-sm group"
            >
              <i class="fas fa-times mr-1 text-sm group-hover:scale-110"></i> ยกเลิก
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { ref } from 'vue';
import dayjs from 'dayjs';

export default {
  name: 'AddCraftModal',
  props: {
    craftTypes: {
      type: Array,
      required: true,
    },
    availableSkills: {
      type: Array,
      required: true,
    },
    isAdding: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['add', 'close'],
  setup(props, { emit }) {
    const error = ref('');
    const newCraftRecipe = ref({
      name: '',
      type: '',
      level: 1,
      materials: [{ itemName: '', quantity: 1 }],
      requiredInt: 0,
      requiredSkill: '',
      maxCrafts: null,
      isRecommended: false,
      expirationDate: '',
      transferChance: 0,
      successChance: 100,
    });

    const addMaterial = () => {
      newCraftRecipe.value.materials.push({ itemName: '', quantity: 1 });
    };

    const removeMaterial = (index) => {
      if (newCraftRecipe.value.materials.length > 1) {
        newCraftRecipe.value.materials.splice(index, 1);
      }
    };

    const addRecipe = () => {
      error.value = '';

      // Validate inputs
      if (
        !newCraftRecipe.value.name.trim() ||
        !newCraftRecipe.value.type ||
        newCraftRecipe.value.level < 1 ||
        newCraftRecipe.value.materials.some((m) => !m.itemName.trim() || m.quantity <= 0) ||
        newCraftRecipe.value.requiredInt < 0 ||
        newCraftRecipe.value.transferChance < 0 ||
        newCraftRecipe.value.transferChance > 100 ||
        newCraftRecipe.value.successChance < 0 ||
        newCraftRecipe.value.successChance > 100 ||
        (newCraftRecipe.value.expirationDate && !dayjs(newCraftRecipe.value.expirationDate).isValid())
      ) {
        error.value = 'กรุณากรอกข้อมูลให้ครบถ้วนและถูกต้อง';
        return;
      }

      // Prepare data for emission
      const recipeData = {
        ...newCraftRecipe.value,
        expirationDate: newCraftRecipe.value.expirationDate
          ? new Date(newCraftRecipe.value.expirationDate).toISOString()
          : null,
      };

      emit('add', recipeData);
    };

    const closeModal = () => {
      error.value = '';
      newCraftRecipe.value = {
        name: '',
        type: '',
        level: 1,
        materials: [{ itemName: '', quantity: 1 }],
        requiredInt: 0,
        requiredSkill: '',
        maxCrafts: null,
        isRecommended: false,
        expirationDate: '',
        transferChance: 0,
        successChance: 100,
      };
      emit('close');
    };

    return {
      error,
      newCraftRecipe,
      addMaterial,
      removeMaterial,
      addRecipe,
      closeModal,
      props,
    };
  },
};
</script>

<style scoped>
.animate-modalFade {
  animation: fadeIn 0.3s ease-in-out;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
.animate-scale {
  animation: scaleIn 0.2s ease-in-out;
}
@keyframes scaleIn {
  from { transform: scale(0.8); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
</style>
```